export const messages = {
  en: {
    adminBarrier: {
      allCommunities: 'All Communities',
      search: {
        title: 'Search Conditions',
        machineCode: 'Please enter device code',
        machineName: 'Please enter device name'
      },
      list: {
        title: 'Barrier Devices'
      },
      table: {
        communityName: 'Community Name',
        machineCode: 'Device Code',
        machineName: 'Device Name',
        machineIp: 'Device IP',
        direction: 'Direction',
        implBeanName: 'Manufacturer',
        boxName: 'Box',
        stateName: 'Status',
        monitorName: 'Monitor',
        heartbeatTime: 'Heartbeat Time',
        createTime: 'Create Time'
      },
      direction: {
        in: 'In',
        out: 'Out'
      }
    }
  },
  zh: {
    adminBarrier: {
      allCommunities: '全部小区',
      search: {
        title: '查询条件',
        machineCode: '请输入设备编码',
        machineName: '请输入设备名称'
      },
      list: {
        title: '道闸设备'
      },
      table: {
        communityName: '小区名称',
        machineCode: '设备编码',
        machineName: '设备名称',
        machineIp: '设备IP',
        direction: '设备方向',
        implBeanName: '道闸厂家',
        boxName: '岗亭',
        stateName: '状态',
        monitorName: '监控',
        heartbeatTime: '心跳时间',
        createTime: '创建时间'
      },
direction: {
        in: '进',
        out: '出'
      }
    }
  },
  'zh-TW': {
    adminBarrier: {
      allCommunities: '全部小區',
      search: {
        title: '查詢條件',
        machineCode: '請輸入設備編碼',
        machineName: '請輸入設備名稱'
      },
      list: {
        title: '道閘設備'
      },
      table: {
        communityName: '小區名稱',
        machineCode: '設備編碼',
        machineName: '設備名稱',
        machineIp: '設備IP',
        direction: '設備方向',
        implBeanName: '道閘廠家',
        boxName: '崗亭',
        stateName: '狀態',
        monitorName: '監控',
        heartbeatTime: '心跳時間',
        createTime: '創建時間'
      },
      direction: {
        in: '進',
        out: '出'
      }
    }
  }
}